export default "/mf-auth/5e4b48d4d582ef66a53d92a48caf1646.svg";